import PropTypes from 'prop-types';

import withSyncedPlayerBehavior from 'src/common/decorators/withSyncedPlayerBehavior';
import cssVariables from 'src/common/styles/variables';
import CircularProgress from '../shared/CircularProgress';
import PopOutButton from '../shared/button/PopOutButton';

import playerStatuses from '../../utils/playerStatuses';
import { playerStatusToSvgIconMap } from '../../utils/playerStatusToIconMap';
import GuideItemLink from '../containerItems/shared/GuideItemLink';
import gtagTrack from '../../utils/gtagTrack';

const styles = {
  icon: {
    color: cssVariables['--secondary-color-5'],
  },
  button: {
    height: '60px',
    width: '60px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
};

export const PlayButton = ({
  canScrub,
  syncedPlayerStatus,
  playerStatus,
  handlePlayButtonClick,
  externalHtmlPlayerUrl,
  guideItem,
}) => {
  if (
    syncedPlayerStatus === playerStatuses.connecting ||
    playerStatus === playerStatuses.preroll
  ) {
    return (
      <div style={styles.button}>
        <CircularProgress
          data-testid="profilePlayerLoadingSpinner"
          color={styles.icon.color}
          thickness={2.5}
        />
      </div>
    );
  }

  if (syncedPlayerStatus === playerStatuses.popout) {
    return (
      <PopOutButton
        externalHtmlPlayerUrl={externalHtmlPlayerUrl}
        width={styles.button.width}
        height={styles.button.height}
        dataTestId="profilePopOutButton"
      />
    );
  }

  const PlayButtonStateRepresentation =
    playerStatusToSvgIconMap[syncedPlayerStatus](canScrub);

  return (
    <GuideItemLink
      guideItem={guideItem}
      onClick={(...args) => {
        gtagTrack.profilePlayButtonClick();
        handlePlayButtonClick(...args);
      }}
    >
      <PlayButtonStateRepresentation
        id="profilePlayerActionButton"
        dataTestId="profilePlayerActionButton"
        width={styles.button.width}
        height={styles.button.height}
      />
    </GuideItemLink>
  );
};

PlayButton.propTypes = {
  syncedPlayerStatus: PropTypes.string.isRequired,
  playerStatus: PropTypes.string.isRequired,
  handlePlayButtonClick: PropTypes.func.isRequired,
  guideItem: PropTypes.object.isRequired,
  canScrub: PropTypes.bool,
  externalHtmlPlayerUrl: PropTypes.string,
};

export default withSyncedPlayerBehavior(PlayButton);
